import {Injectable} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';

type AddOrRemove = 'add' | 'remove';

export const EXPANDED_ROW_CLASS_NAME = 'mx-expandable-row-expanded';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in -- For table component use only -- not globally injectable.
@Injectable()
export class RowExpansionService<RowObject> {
  // Individually keep track of expanded and collapsed rows, since they can be defaulted (overridden).
  private readonly expandedRows = new SelectionModel<RowObject>(true);
  private readonly collapsedRows = new SelectionModel<RowObject>(true);
  private initiallyExpandedFor: (row: RowObject) => boolean = () => false;

  public initializeInitiallyExpandedFor(selector: (row: RowObject) => boolean): void {
    this.initiallyExpandedFor = selector;
  }

  public isExpanded(row: RowObject): boolean {
    if (this.expandedRows.isSelected(row)) {
      return true;
    }
    if (this.collapsedRows.isSelected(row)) {
      return false;
    }
    return this.initiallyExpandedFor(row);
  }

  public toggleExpansionFor(rowObject: RowObject, tableRow: HTMLTableRowElement): void {
    const currentlyExpanded = this.isExpanded(rowObject);

    if (currentlyExpanded) {
      this.expandedRows.deselect(rowObject);
      this.collapsedRows.select(rowObject);
    } else {
      this.collapsedRows.deselect(rowObject);
      this.expandedRows.select(rowObject);
    }

    const addOrRemove: AddOrRemove = this.isExpanded(rowObject) ? 'add' : 'remove';
    this.updateClassForRowAbove(tableRow, addOrRemove);
    this.updateClassForRow(tableRow, addOrRemove);
  }

  // if hawk ever becomes responsive, we'll need to preserve mx-expandable-row-next-row-expanded on resize in table.generateRowExpansionCssClassesFor
  private updateClassForRowAbove(tableRow: HTMLTableRowElement, addOrRemove: AddOrRemove): void {
    const previousTableRow: Element | null = tableRow.previousElementSibling;

    if (previousTableRow?.nodeName.toLowerCase() === 'tr') previousTableRow.classList[addOrRemove]('mx-expandable-row-next-row-expanded');
  }

  private updateClassForRow(tableRow: HTMLTableRowElement, addOrRemove: AddOrRemove): void {
    tableRow.classList[addOrRemove](EXPANDED_ROW_CLASS_NAME);
  }
}
